import { BuildingAndFloor } from '@/features/floormaps/components/BuildingAndFloor'

export function TrackLocationsView() {
  return <BuildingAndFloor page="track-location"></BuildingAndFloor>
}
